import { render } from "./weChatLogin.vue?vue&type=template&id=0ac0af0e&scoped=true"
import script from "./weChatLogin.vue?vue&type=script&lang=js"
export * from "./weChatLogin.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac0af0e"]])

export default __exports__